'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Site(id, created, deleted, account, active, name, url, twoFactorAuth, expressLogin, credentials, signer, realm, scope, system, login, path) {
  this.e3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.LL = null;
  this.LM = null;
  this.ue = null;
  this.LK = false;
  this.km = null;
  this.n8 = null;
  this.oF = false;
  this.uf = false;
  this.s1 = null;
  this.uh = null;
  this.oE = null;
  this.qu = null;
  this.s2 = null;
  this.ug = null;
  this.EE = null;
  this.e3 = id;
  this.LL = created;
  this.LM = deleted;
  this.ue = account;
  this.LK = active;
  this.km = name;
  this.n8 = url;
  this.oF = twoFactorAuth;
  this.uf = expressLogin;
  this.s1 = credentials;
  this.uh = signer;
  this.oE = realm;
  this.qu = scope;
  this.s2 = system;
  this.ug = login;
  this.EE = path;
}
export { $c_Lpresto_types$Site as $c_Lpresto_types$Site };
$p = $c_Lpresto_types$Site.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Site;
/** @constructor */
function $h_Lpresto_types$Site() {
}
export { $h_Lpresto_types$Site as $h_Lpresto_types$Site };
$h_Lpresto_types$Site.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Site"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.e3;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.LL));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.LM));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.ue));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.LK ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.km));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.n8));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.oF ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.uf ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.s1));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.uh));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.oE));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.qu));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.s2));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.ug));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.EE));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 16);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Site)) {
    if ((((this.LK === x$0.LK) && (this.oF === x$0.oF)) && (this.uf === x$0.uf))) {
      var this$1 = this.e3;
      var b = x$0.e3;
      var $x_10 = ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x = this.LL;
      var x$2 = x$0.LL;
      var $x_9 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$3 = this.LM;
      var x$4 = x$0.LM;
      var $x_8 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$5 = this.ue;
      var x$6 = x$0.ue;
      var $x_7 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_7 = false;
    }
    if ((($x_7 && (this.km === x$0.km)) && (this.n8 === x$0.n8))) {
      var x$7 = this.s1;
      var x$8 = x$0.s1;
      var $x_6 = ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$9 = this.uh;
      var x$10 = x$0.uh;
      var $x_5 = ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$11 = this.oE;
      var x$12 = x$0.oE;
      var $x_4 = ((x$11 === null) ? (x$12 === null) : x$11.i(x$12));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$13 = this.qu;
      var x$14 = x$0.qu;
      var $x_3 = ((x$13 === null) ? (x$14 === null) : x$13.i(x$14));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$15 = this.s2;
      var x$16 = x$0.s2;
      var $x_2 = ((x$15 === null) ? (x$16 === null) : x$15.i(x$16));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$17 = this.ug;
      var x$18 = x$0.ug;
      var $x_1 = ((x$17 === null) ? (x$18 === null) : x$17.i(x$18));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$19 = this.EE;
      var x$20 = x$0.EE;
      return ((x$19 === null) ? (x$20 === null) : x$19.i(x$20));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 16;
});
$p.s = (function() {
  return "Site";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.e3;
      break;
    }
    case 1: {
      return this.LL;
      break;
    }
    case 2: {
      return this.LM;
      break;
    }
    case 3: {
      return this.ue;
      break;
    }
    case 4: {
      return this.LK;
      break;
    }
    case 5: {
      return this.km;
      break;
    }
    case 6: {
      return this.n8;
      break;
    }
    case 7: {
      return this.oF;
      break;
    }
    case 8: {
      return this.uf;
      break;
    }
    case 9: {
      return this.s1;
      break;
    }
    case 10: {
      return this.uh;
      break;
    }
    case 11: {
      return this.oE;
      break;
    }
    case 12: {
      return this.qu;
      break;
    }
    case 13: {
      return this.s2;
      break;
    }
    case 14: {
      return this.ug;
      break;
    }
    case 15: {
      return this.EE;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function() {
  return this.km;
});
$p.agr = (function() {
  return this.n8;
});
$p.cul = (function() {
  return this.ug;
});
$p.Hq = (function() {
  return ("s#" + this.e3);
});
$p.aeR = (function(nameOrUrl) {
  var lower = nameOrUrl.toLowerCase();
  var this$1 = this.km;
  var this$2 = this$1.toLowerCase();
  if (((this$2.indexOf(lower) | 0) !== (-1))) {
    return true;
  } else {
    var this$3 = this.n8;
    var this$4 = this$3.toLowerCase();
    return ((this$4.indexOf(lower) | 0) !== (-1));
  }
});
$p.k4 = (function() {
  return this.e3;
});
function $isArrayOf_Lpresto_types$Site(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ki)));
}
export { $isArrayOf_Lpresto_types$Site as $isArrayOf_Lpresto_types$Site };
var $d_Lpresto_types$Site = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Site, "presto.types$Site", ({
  ki: 1,
  aH: 1,
  kj: 1,
  ed: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Site as $d_Lpresto_types$Site };
//# sourceMappingURL=presto.types$-Site.js.map
